<header class="dialog-header">
  <h2 id="dialogo-fechar-aba-titulo">Fechar aba</h2>
</header>

<div class="dialog-body">
  <p>
    Tem certeza que deseja fechar a aba <strong class="tab-name">{{ data.title }}</strong
    >?
  </p>
  <p class="warning">O código que não foi baixado será perdido.</p>
</div>

<footer class="dialog-footer">
  <button type="button" class="btn" (click)="dialogRef.close(false)">Manter aberta</button>
  <button type="button" class="btn btn-primary" cdkFocusInitial (click)="dialogRef.close(true)">Fechar aba</button>
</footer>
